import ConnectVehicleCard from '@/authenticated/components/Onboarding/ConnectVehicleCard'
import { useAppDispatch, useUrlSearchParam } from '@/hooks'
import { usePostAuthRedirectUrl } from '@/hooks/useDeviceSelectionRedirectUrl'
import { utilityProgramEnrollmentCollection } from '@/reducers/utilityProgramEnrollments'
import { vehicleEnrollmentCollection } from '@/reducers/deviceProgramEnrollments'
import { useHistory } from 'react-router-dom'
import { surveyResponsesCollection } from '@/reducers/surveyResponses'
import { utilityProgramCollection } from '@/reducers/utilityPrograms'
import NavigationPage from '@/app/components/NavigationPage'
import { programsNewCollection } from '@/reducers/programsNew'
import useMultiProgramFlowControl from '@/hooks/useMultiProgramFlowControl'
import { AlertMessage } from '@/app/components'

export default function ConnectVehicle() {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const onFinishRedirect = usePostAuthRedirectUrl()
  const { inFlow, popFlowUri } = useMultiProgramFlowControl()
  const showAlert = useUrlSearchParam('showAlert')

  const onFinish = () => {
    dispatch(utilityProgramEnrollmentCollection.actions.invalidate())
    dispatch(utilityProgramCollection.actions.invalidate())
    dispatch(vehicleEnrollmentCollection.actions.invalidate())
    dispatch(surveyResponsesCollection.actions.fetch())
    dispatch(programsNewCollection.actions.invalidate())
    // If we're in a multi-program flow, navigate back to its enrollment page
    if (inFlow) {
      history.push(popFlowUri())
      return
    }
    history.push(onFinishRedirect)
  }

  const postInelgibleSurveyAlert = (
    <AlertMessage variant="success" className="mb-4">
      Thanks for letting us know! We’ll keep you posted if you asked for
      updates.
    </AlertMessage>
  )

  return (
    <>
      <NavigationPage
        id="connect-vehicle"
        preHeaderContent={
          showAlert === 'true' ? postInelgibleSurveyAlert : null
        }
        headerClassName="!mb-0"
      >
        <NavigationPage.SingleCardContent>
          <ConnectVehicleCard
            onFinish={onFinish}
            onTeslaConnectionEnd={onFinish}
            onTeslaConnectionHappened={() => {}}
            awaitingTeslaConfirmation={false}
          />
        </NavigationPage.SingleCardContent>
      </NavigationPage>
    </>
  )
}
